import AudienceAutoUpdate from './AudienceAutoUpdate.Container';

export default AudienceAutoUpdate;
